import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useRequest } from "@companion-core/shared/app/Queries";
import { useCrossSellConcierges } from "@companion-core/shared/app/Queries/crossSell";

export const useCrossSell = (request: {
  id?: string;
  family?: string;
  subFamily?: string;
  enabled?: boolean;
}) => {
  const { t, i18n } = useTranslation();
  const {
    data: requestData,
    isLoading: isRequestLoading,
    isError: isRequestError,
  } = useRequest(request.id ?? "", !!request.id && request.enabled);

  const {
    data,
    isLoading: isCrossSellLoading,
    isError: isCrossSellError,
  } = useCrossSellConcierges(
    request.family ?? requestData?.data?.result?.family,
    request.subFamily ?? requestData?.data?.result?.sub_family,
    i18n.language,
    ((!!request.family && !!request.subFamily) || (!!requestData && !isRequestLoading)) && request.enabled,
  );

  const isLoading = useMemo(
    () => isRequestLoading || isCrossSellLoading,
    [isRequestLoading, isCrossSellLoading],
  );

  const isError = useMemo(
    () => isRequestError || isCrossSellError,
    [isRequestError, isCrossSellError],
  );

  return {
    t,
    data: data?.data?.results,
    isLoading,
    isError,
  };
};
